// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"8181d516","451":"d02a08ee"}[chunkId] + ".chunk.css";
};